const en = {
  // Generic
  reset: "Reset",
  resetFilters: "Reset filters",
  hidden: "Hidden",
  rejected: "Rejected",
  reject: "Reject",
  working: "Working…",
  choose: "Choose…",
  added: "Added",
  draftParen: "(draft)",
  new: "New",
  newBreadcrumb: "New",
  details: "Details",
  applyEllipsis: "Apply…",
  viewOnStore: "View on store ↗",
  unsavedChanges: "Unsaved changes",
  charCount: "{count} / {max} characters",
  productCount: "{count} products",
  productCount_one: "{count} product",
  selectedCount: "{count} selected",
  exportCsv: "Export CSV",
  importCsv: "Import CSV",
  import: "Import",
  product: "Product",
  collection: "Collection",
  sku: "SKU",
  barcode: "Barcode",
  tag: "Tag",
  vendor: "Vendor",
  tags: "Tags",
  image: "Image",
  noAltText: "No alt text",
  altText: "Alt: {alt}",
  pageTitle: "Page title",
  metaDescription: "Meta description",
  urlHandle: "URL handle",
  seoListing: "Search engine listing",
  visibility: "Visibility",

  // Product types
  typePhysical: "Physical",
  typeDigital: "Digital",
  typeService: "Service",
  typePhysicalLong: "Physical — shipped to the customer",
  typeDigitalLong: "Digital — file download",
  typeServiceLong: "Service — no shipping",

  // Stock states
  inStock: "In stock",
  lowStock: "Low stock",
  outOfStock: "Out of stock",
  notTracked: "Not tracked",
  tracked: "Tracked",
  onHand: "On hand",
  reserved: "Reserved",
  available: "Available",

  // Products list
  productsDescription: "Everything you sell — physical goods, digital downloads and services.",
  addProduct: "Add product",
  productDeleted: "Product deleted.",
  productSearchPlaceholder: "Title, vendor, SKU or exact tag",
  statusAllNotArchived: "All (not archived)",
  allTypes: "All types",
  anyCollection: "Any collection",
  stock: "Stock",
  anyStock: "Any stock",
  sort: "Sort",
  sortNewest: "Newest",
  sortOldest: "Oldest",
  sortTitle: "Title A–Z",
  sortPriceAsc: "Price: low to high",
  sortPriceDesc: "Price: high to low",
  sortStock: "Stock: lowest first",
  noProductsMatch: "No products match these filters",
  noProductsMatchHint: "Try a different search or reset the filters.",
  emptyProductsTitle: "Add your first product",
  emptyProductsBody: "Products appear in your store once they're active. You can also import a CSV from another platform.",

  // Product table / bulk actions
  bulkSetActive: "Set status: Active",
  bulkSetDraft: "Set status: Draft",
  bulkSetArchived: "Set status: Archived",
  bulkPricePercent: "Adjust prices by %",
  bulkAddToCollection: "Add to collection",
  bulkRemoveFromCollection: "Remove from collection",
  bulkAddTag: "Add tag",
  bulkSummaryIncrease: "Increase the price of every variant of {products} by {percent}%. Compare-at prices that would no longer be higher than the price are cleared.",
  bulkSummaryDecrease: "Decrease the price of every variant of {products} by {percent}%. Compare-at prices that would no longer be higher than the price are cleared.",
  bulkSummaryAddCollection: "Add {products} to “{collection}”.",
  bulkSummaryRemoveCollection: "Remove {products} from “{collection}”.",
  bulkSummaryAddTag: "Add the tag “{tag}” to {products}.",
  bulkSummaryArchive: "Archive {products}. Archived products are hidden from your store but kept for order history.",
  bulkSummaryActive: "Set status to Active for {products}.",
  bulkSummaryDraft: "Set status to Draft for {products}.",
  bulkActions: "Bulk actions",
  bulkAction: "Bulk action",
  chooseAction: "Choose action…",
  percentChange: "Percent change",
  percentPlaceholder: "e.g. 10 or -15",
  chooseCollection: "Choose collection…",
  confirmBulkUpdate: "Confirm bulk update",
  updating: "Updating…",
  updateCount: "Update {count}",
  selectAllOnPage: "Select all products on this page",
  selectProduct: "Select {title}",
  variantsCount: "{count} variants",
  singleVariant: "Single variant",
  availableCount: "{count} available",
  lowShort: "low",

  // Product actions (server)
  enterPrice: "Enter a price",
  amountNegative: "Amount can't be negative",
  enterValidAmount: "Enter a valid amount",
  formUnreadable: "The form couldn't be read. Reload the page and try again.",
  checkPrices: "Check the highlighted prices.",
  productSaved: "Product saved.",
  productArchivedInstead: "This product appears in past orders, so it was archived instead of deleted. Order history keeps its details.",
  chooseActionError: "Choose an action",
  enterPercentChange: "Enter a percentage change, e.g. 10 or -15.",
  enterPercentage: "Enter a percentage",
  chooseCollectionError: "Choose a collection.",
  chooseCollectionField: "Choose a collection",
  bulkUpdated: "Updated {count} products.",
  bulkUpdated_one: "Updated {count} product.",
  chooseCsvFile: "Choose a CSV file to upload.",
  chooseCsvField: "Choose a CSV file",
  csvTooLarge: "CSV files can be up to 5 MB.",
  fileTooLarge: "File too large",
  importErrorsDry: "{count} products have errors. Fix the rows below and validate again.",
  importErrorsDry_one: "{count} product has errors. Fix the rows below and validate again.",
  importErrorsReal: "{count} products had errors and were skipped. Fix the rows below and import again.",
  importErrorsReal_one: "{count} product had errors and was skipped. Fix the rows below and import again.",
  importValid: "File is valid: {created} product(s) would be created and {updated} updated. Nothing was saved yet.",
  importComplete: "Import complete: {created} created, {updated} updated.",

  // Product pages
  editProduct: "Edit product",
  productCreated: "Product created.",
  productDuplicated: "Duplicated as a draft. SKUs and stock were not copied — set them before activating.",
  duplicate: "Duplicate",
  duplicateTitle: "Duplicate this product?",
  duplicateBody: "Creates a draft copy with the same details, images and prices. SKUs, barcodes and stock are not copied.",
  deleteProductTitle: "Delete this product?",
  deleteProduct: "Delete product",
  deleteProductBody: "If this product appears in any past order it will be <b>archived instead</b> so order history stays intact. Otherwise it is permanently deleted with its variants and stock history.",

  // Import
  importProducts: "Import products",
  importPricesCurrency: "Prices are read in your store currency ({currency}).",
  expectedColumns: "Expected columns",
  template: "Template",
  exportCurrent: "Export current",
  csvHeaderHelp: "The header row must include at least {handle} and {price}. Column order doesn't matter.",
  csvHelpHandle: "Required. URL handle; rows with the same handle are variants of one product.",
  csvHelpTitle: "Required on a product's first row.",
  csvHelpDescription: "Plain text / markdown-lite.",
  csvHelpType: "physical, digital or service (default physical).",
  csvHelpStatus: "draft, active or archived (default draft).",
  csvHelpVendor: "Brand or maker.",
  csvHelpTags: "Separate tags with |",
  csvHelpOption1Name: "e.g. Size (first row of the product).",
  csvHelpOption1Value: "e.g. M (every row).",
  csvHelpSku: "Unique per store.",
  csvHelpPrice: "Required. Decimal, e.g. 24.00",
  csvHelpCompareAt: "Optional. Must be higher than price.",
  csvHelpCost: "Optional cost per item.",
  csvHelpStock: "Whole number; sets on-hand stock.",
  csvHelpTrackInventory: "true/false (default true).",
  csvHelpWeight: "Whole number of grams.",
  uploadCsv: "Upload CSV",
  uploadCsvDescription: "Products are matched by handle: existing handles are updated, new ones are created. Validate first — nothing is saved until you import.",
  csvFile: "CSV file",
  csvFileHint: "UTF-8 CSV, up to 5 MB and 5,000 rows.",
  validating: "Validating…",
  importing: "Importing…",
  validateOnly: "Validate only",
  validationResults: "Validation results",
  importResults: "Import results",
  dryRunNothingSaved: "dry run, nothing was saved",
  wouldCreate: "Would create",
  created: "Created",
  wouldUpdate: "Would update",
  updated: "Updated",
  withErrors: "With errors",
  row: "Row",
  rowN: "Row {row}",
  problem: "Problem",

  // Product editor
  productNotSaved: "Product not saved",
  productTitlePlaceholder: "e.g. Organic cotton tee",
  productDescriptionHint: "Markdown-lite: blank line between paragraphs, “## ” for a heading, “- ” for bullets, **bold** and [link text](https://…).",
  media: "Media",
  mediaHint: "The first image is the main product photo. Images must be public library images.",
  mainImage: "Main",
  moveImageEarlier: "Move image {n} earlier",
  moveImageLater: "Move image {n} later",
  removeImageNamed: "Remove image {name}",
  uploadImages: "Upload images",
  altTextHint: "Alt text describes an image for screen readers and search engines — edit it in the Media library.",
  digitalFile: "Digital file",
  digitalFileHint: "Delivered to customers after payment through expiring, limited download links. Stored privately — never publicly accessible.",
  fileSizePrivate: "{size} MB · private",
  noFileAttached: "No file attached yet. Customers can’t receive this product until you upload one.",
  replaceFile: "Replace file",
  uploadFile: "Upload file",
  downloadLimit: "Download limit",
  downloadLimitHint: "Downloads allowed per purchase (1–100).",
  linkExpiry: "Link expiry (days)",
  linkExpiryHint: "Days the download link stays valid (1–365).",
  options: "Options",
  optionsHint: "Up to 3 options such as Size or Color. Variants are generated for every combination.",
  optionName: "Option {n} name",
  optionNamePlaceholder: "e.g. Size",
  values: "Values",
  valuesHint: "Separate values with Enter or a comma.",
  valuesPlaceholder: "e.g. S, M, L",
  optionNamesUnique: "Option names must be unique.",
  addOption: "+ Add option",
  variantsMaxWarning: "{count} variants — the maximum is 250.",
  pricing: "Pricing",
  compareAtPrice: "Compare-at price",
  compareAtHint: "Original price shown crossed out.",
  costPerItem: "Cost per item",
  barcodeFull: "Barcode (ISBN, UPC, GTIN…)",
  digitalNotTracked: "Digital products aren’t stock-tracked.",
  servicesNotTracked: "Services aren’t stock-tracked.",
  variantsTitle: "Variants ({count})",
  variantsHint: "Existing variants keep their prices, stock and history when you change options.",
  priceForAll: "Price for all variants",
  applyToAll: "Apply to all",
  variant: "Variant",
  defaultVariant: "Default",
  priceFor: "Price for {label}",
  skuFor: "SKU for {label}",
  stockFor: "Stock on hand for {label}",
  variantImage: "Variant image",
  addImagesFirst: "Add product images first.",
  noSpecificImage: "No specific image",
  imageOption: "Image {n} — {name}",
  requiresShipping: "This is a physical product that requires shipping",
  weightGrams: "Weight (grams)",
  weightHint: "Used for weight-based shipping rates. Your store shows weights in {unit}; enter grams here (1 kg = 1000 g, 1 lb ≈ 454 g).",
  weightPerVariantHint: "Set each variant’s weight (in grams) under Details.",
  noShippingDigital: "Digital products are delivered by download — no shipping is charged.",
  seoProductHint: "How this product appears in search results.",
  seoTitlePlaceholder: "Product title",
  seoDescriptionPlaceholder: "Add a description to show a summary here.",
  slugHint: "Lowercase letters, numbers and hyphens. Leave empty to generate from the title.",
  slugHintExisting: "Lowercase letters, numbers and hyphens. Leave empty to generate from the title. Changing it breaks existing links.",
  statusDraftLong: "Draft — hidden from the store",
  statusActiveLong: "Active — visible and purchasable",
  statusArchivedLong: "Archived — hidden, kept for records",
  organization: "Organization",
  productType: "Product type",
  tagsHint: "Used for search, filters and automatic collections.",
  noManualCollections: "No manual collections yet.",
  createOne: "Create one",
  automaticCollectionsHint: "Automatic collections add this product when it matches their rules.",
  tax: "Tax",
  chargeTax: "Charge tax on this product",
  taxClass: "Tax class",
  taxClassHint: "Optional. Matches tax rates with the same class (e.g. reduced). Leave empty for the standard rate.",
  createProduct: "Create product",
  trackInventory: "Track inventory",
  trackInventoryHint: "Stock decreases with each order.",
  continueSelling: "Continue selling when out of stock",
  continueSellingHint: "Allows backorders.",
  stockOnHand: "Stock on hand",
  stockReservedHint: "{count} reserved by open checkouts. Changes are logged.",
  stockLoggedHint: "Changes are logged in inventory history.",
  initialStockHint: "Recorded as initial stock.",
  lowStockAlertAt: "Low-stock alert at",
  lowStockAlertHint: "Flag when available stock reaches this.",
  weightStoreHint: "Store displays {unit}; enter grams.",
  customersWontSee: "Customers won’t see this.",
  marginHint: "Margin {margin}% · customers won’t see this.",

  // Pickers / inputs
  typeAndEnter: "Type and press Enter",
  removeTag: "Remove {tag}",
  searchProducts: "Search products",
  searchProductsPlaceholder: "Search products by title or SKU",
  noProductsSelected: "No products selected.",
  moveUp: "Move {title} up",
  moveDown: "Move {title} down",
  removeItem: "Remove {title}",
  chooseFromLibrary: "Choose from library",
  searchFiles: "Search files",
  searchByFileName: "Search by file name",
  uploadNew: "Upload new",
  mediaLoadError: "Couldn't load the media library.",
  noImagesMatch: "No images match your search.",
  libraryEmpty: "Your media library is empty. Upload an image to get started.",
  loadMore: "Load more",
  selectImages: "Select one or more images",
  selectImage: "Select an image",
  addSelected: "Add selected",
  useImage: "Use image",

  // Collections
  collectionsDescription: "Group products for navigation, landing pages and discounts.",
  createCollection: "Create collection",
  editCollection: "Edit collection",
  collectionDeleted: "Collection deleted. Its products were not affected.",
  collectionCreated: "Collection created.",
  collectionSaved: "Collection saved.",
  noCollections: "No collections yet",
  noCollectionsBody: "Create a collection like “New arrivals” or “Under $25” to help customers browse.",
  manual: "Manual",
  automatic: "Automatic",
  ruleSummaryTag: "tag = {value}",
  ruleSummaryType: "type = {value}",
  ruleSummaryVendor: "vendor = {value}",
  ruleSummaryPriceLte: "price ≤ {amount}",
  ruleSummaryPriceGte: "price ≥ {amount}",
  deleteCollectionTitle: "Delete this collection?",
  deleteCollection: "Delete collection",
  deleteCollectionBody: "The collection is removed from your store. Products in it are not deleted. Discounts limited to this collection will no longer match it.",
  enterValue: "Enter a value",
  chooseProductType: "Choose a product type",
  checkRules: "Check the collection rules.",
  ruleTag: "Product tag is",
  ruleType: "Product type is",
  ruleVendor: "Vendor is",
  rulePriceLte: "Price is at most",
  rulePriceGte: "Price is at least",
  collectionTitlePlaceholder: "e.g. Summer sale",
  collectionDescriptionHint: "Shown at the top of the collection page. Markdown-lite supported.",
  collectionType: "Collection type",
  collectionTypeHint: "Manual collections hold products you pick. Automatic collections include every product matching all rules.",
  manualHint: "Choose and order products yourself.",
  automaticHint: "Products are added by tag, type, vendor or price.",
  switchToAutomaticWarning: "Switching to automatic removes the hand-picked products from this collection.",
  matchAllRules: "Products must match all of these rules",
  ruleCondition: "Rule {n} condition",
  ruleValue: "Rule {n} value",
  tagPlaceholder: "e.g. summer",
  vendorPlaceholder: "e.g. Acme",
  addRule: "+ Add rule",
  currentlyMatching: "Currently matching (saved rules)",
  noProductsMatchYet: "No products match yet.",
  collectionNoProducts: "No products yet — search above to add some.",
  manualOrderHint: "The order here is used when the collection is sorted manually.",
  urlPreview: "Preview: {url}",
  publishedHint: "Visible in your store's navigation and collection pages.",
  sortProductsBy: "Sort products by",
  sortManual: "Manual order",
  sortNewestFirst: "Newest first",
  removeImage: "Remove image",
  noImage: "No image.",
  uploadImage: "Upload image",

  // Inventory
  inventoryDescription: "Stock levels for every variant. Available = on hand − reserved (held for unpaid orders and checkouts).",
  trackedVariants: "Tracked variants",
  unitsOnHand: "Units on hand",
  lowStockHint: "At or below threshold",
  inventorySearchPlaceholder: "Product, variant, SKU or barcode",
  allVariants: "All variants",
  lowInclOut: "Low (incl. out)",
  nothingMatches: "Nothing matches",
  nothingMatchesHint: "Try a different search or filter.",
  noInventory: "No inventory yet",
  noInventoryBody: "Add a product to start tracking stock.",
  threshold: "Threshold",
  backordersAllowed: "Backorders allowed",
  history: "History",
  stockHistory: "Stock history",
  stockHistoryDescription: "Stock movement history (newest first).",
  currentStock: "Current stock",
  tracking: "Tracking",
  lowStockAt: "Low-stock at",
  movements: "Movements",
  movementsHint: "Reservations hold stock for unpaid orders; they don't change on-hand.",
  noMovements: "No movements yet",
  noMovementsBody: "Adjustments, sales, returns and reservations will appear here.",
  event: "Event",
  change: "Change",
  onHandAfter: "On hand after",
  reasonReference: "Reason / reference",
  by: "By",
  reservedCount: "{count} reserved",
  viewOrder: "View order",
  system: "System",
  kindAdjustment: "Adjustment",
  kindReceipt: "Received",
  kindOrder: "Sold",
  kindCancellation: "Cancelled order",
  kindReturn: "Restocked (refund/return)",
  kindReservation: "Reserved",
  kindReservationRelease: "Reservation released",
  kindImport: "Import",
  noStockChange: "No change — stock already at that level.",
  stockChanged: "On hand: {before} → {after}",

  // Adjust stock
  adjust: "Adjust",
  adjustStockTitle: "Adjust stock — {label}",
  saveAdjustment: "Save adjustment",
  adjustReservedNote: "{count} reserved by unpaid orders/checkouts",
  adjustLogged: "Every adjustment is logged with your name and reason.",
  adjustmentType: "Adjustment type",
  addRemove: "Add / remove",
  setTo: "Set to",
  changeLabel: "Change (use − for removals)",
  newOnHand: "New on-hand quantity",
  onHandAfterValue: "On hand after: {count}",
  onHandAfterNegative: "On hand after: {count} — can't go below 0",
  deltaPlaceholder: "e.g. 12 or -2",
  setPlaceholder: "e.g. 40",
  reason: "Reason",
  reasonReceived: "Received stock",
  reasonDamaged: "Damaged",
  reasonCorrection: "Correction",
  reasonReturned: "Returned",
  reasonOther: "Other",
  note: "Note",
  noteRequiredOther: "Required for “Other”.",
  noteHint: "e.g. PO number or supplier.",

  // Reviews
  reviewsDescription: "New reviews wait here until you publish them. Verified purchase is set automatically from paid orders — reviewers can't claim it.",
  reviewsNotInPlan: "Product reviews aren't included in your current plan, so customers can't submit new ones. Existing reviews can still be moderated.",
  noReviewsWaiting: "No reviews waiting",
  noReviewsHere: "No reviews here",
  reviewsCaughtUp: "You're all caught up. New customer reviews will appear here for approval.",
  reviewsModeratedHere: "Reviews you moderate will show up in this list.",
  starsAria: "{rating} out of 5 stars",
  verifiedPurchase: "Verified purchase",
  reportedTimes: "Reported {count}×",
  reviewOn: "on",
  viewOnStoreLower: "view on store ↗",
  deleteReviewTitle: "Delete this review?",
  deleteReviewBody: "The review is permanently removed. Rejecting keeps it hidden instead.",
  reviewDeleted: "Deleted.",
  reviewPublished: "Published.",
  reviewRejected: "Rejected.",
};

export default en;
